module.exports = __webpack_public_path__ + "assets/img/The_Benefits_of_Listing.8d772a46.png";